import { Form, Select, InputNumber, Input, FormInstance } from "antd";
import ImagePicker from "../../form/ImagePicker";

interface VendorTransactionFieldsProps {
  form: FormInstance;
}

// The exact set of fields used everywhere a vendor transaction is created —
// the "Add Transaction" modal and the standalone Add Expense page both render
// this so the form stays identical in both places.
const VendorTransactionFields = ({ form }: VendorTransactionFieldsProps) => {
  const paymentType = Form.useWatch('paymentType', form);
  const isPartial    = paymentType === 'partial';
  const paymentMode  = Form.useWatch('paymentMode', form);
  const isOnline     = paymentMode === 'online';

  return (
    <>
      <Form.Item name="amount" label="Amount" rules={[{ required: true, message: 'Please enter amount' }]}>
        <InputNumber style={{ width: '100%' }} min={0} placeholder="Enter amount" />
      </Form.Item>

      <Form.Item name="paymentType" label="Payment Type" rules={[{ required: true, message: 'Please select payment type' }]}>
        <Select
          placeholder="Select payment type"
          options={[
            { value: 'full',    label: 'Full' },
            { value: 'partial', label: 'Partial' },
          ]}
        />
      </Form.Item>

      {/* Outstanding disabled for now — wallet-only until that flow is ready. */}
      <Form.Item name="paidVia" label="Paid Via" initialValue="wallet" rules={[{ required: true, message: 'Please select how it was paid' }]}>
        <Select
          placeholder="Select paid via"
          options={[
            { value: 'wallet', label: 'Wallet' },
          ]}
        />
      </Form.Item>

      {isPartial && (
        <>
          <Form.Item name="paidAmount" label="Paid Amount" rules={[{ required: true, message: 'Please enter paid amount' }]}>
            <InputNumber style={{ width: '100%' }} min={0} placeholder="Enter paid amount" />
          </Form.Item>

          <Form.Item shouldUpdate label="Pending Amount">
            {() => {
              const amount     = form.getFieldValue('amount') || 0;
              const paidAmount = form.getFieldValue('paidAmount') || 0;
              const pending    = Math.max(amount - paidAmount, 0);
              return (
                <InputNumber
                  style={{ width: '100%' }}
                  value={pending}
                  disabled
                  formatter={(v) => `₹${v}`}
                />
              );
            }}
          </Form.Item>
        </>
      )}

      <Form.Item name="paymentMode" label="Payment Mode" rules={[{ required: true, message: 'Please select payment mode' }]}>
        <Select
          placeholder="Select payment mode"
          onChange={(mode) => { if (mode === 'cash') form.setFieldsValue({ paymentBill: undefined }); }}
          options={[
            { value: 'cash',   label: 'Cash' },
            { value: 'online', label: 'Online' },
          ]}
        />
      </Form.Item>

      <Form.Item name="bill" label="Bill" className="field-span-2" rules={[{ required: true, message: 'Please upload the bill' }]}>
        <ImagePicker form={form} name="bill" />
      </Form.Item>

      {isOnline && (
        <Form.Item name="paymentBill" label="Payment Proof" className="field-span-2" rules={[{ required: true, message: 'Please upload the online payment proof' }]}>
          <ImagePicker form={form} name="paymentBill" />
        </Form.Item>
      )}

      <Form.Item name="description" label="Description" className="field-span-2">
        <Input placeholder="Enter description (optional)" />
      </Form.Item>
    </>
  );
};

export default VendorTransactionFields;
